import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { BottomNav } from "./BottomNav";
import { InactivityLogout } from "./InactivityLogout";
import { ImpersonationBanner } from "./ImpersonationBanner";

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <InactivityLogout />
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="lg:ml-64 pb-20 lg:pb-8">
        <div className="sticky top-16 z-30 lg:top-0">
          <ImpersonationBanner />
        </div>
        <Outlet />
      </main>

      <BottomNav onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
    </div>
  );
}
